import { render, staticRenderFns } from "./RelatorioContasAReceberView.vue?vue&type=template&id=4b956ba0&scoped=true"
import script from "./RelatorioContasAReceberView.vue?vue&type=script&lang=js"
export * from "./RelatorioContasAReceberView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioContasAReceberView.vue?vue&type=style&index=0&id=4b956ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b956ba0",
  null
  
)

export default component.exports